import { render, staticRenderFns } from "./collect_view.vue?vue&type=template&id=44cd3888&scoped=true&"
import script from "./collect_view.vue?vue&type=script&lang=js&"
export * from "./collect_view.vue?vue&type=script&lang=js&"
import style0 from "./collect_view.vue?vue&type=style&index=0&id=44cd3888&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "44cd3888",
  null
  
)

export default component.exports